// 9fbef606107a605d69c0edbcd8029e5d
import { executeStatefulAPICall } from '../../handler';
import endpoints from '../../endpoints';

const getFormattedData = (res) => {
  const { data } = res;
  return {
    venmoClientTokenData: {
      userState: data?.userState,
      venmoCustomerIdAvailable: data?.customerIdAvailable,
      venmoIsDefaultPaymentType: data?.defaultPaymentType,
      venmoPaymentTokenAvailable: data?.paymentTokenAvailable,
      venmoSecurityToken: data?.securityToken,
    },
  };
};

export const getVenmoToken = ({ userState, orderId }) => {
  const payload = {
    body: {
      basketId: orderId,
      userState,
    },
    webService: endpoints.getVenmoClientToken,
  };
  return executeStatefulAPICall(payload)
    .then((res) => {
      const massagedData = getFormattedData(res.body);
      return massagedData || {};
    })
    .catch((err) => {
      throw err;
    });
};
export default getVenmoToken;
